import { ProjectEstimateVariableBase } from './base/project-estimate-variable-base';

export class ProjectEstimateVariable extends ProjectEstimateVariableBase { }